export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_4W_38_95_1W_5_54',
	providers: {
		paltaMap: {
			USD: 'simple_premium_4w_38_95_1w_5_54_usd',
			EUR: 'simple_premium_4w_38_95_1w_5_54_eur',
			GBP: 'simple_premium_4w_38_95_1w_5_54_gbp',
			AUD: 'simple_premium_4w_59_99_1w_8_79_aud',
			CAD: 'simple_premium_4w_49_99_1w_7_99_cad',
			DKK: 'simple_premium_4w_259_1w_31_99_dkk',
			SEK: 'simple_premium_4w_369_1w_52_79_sek',
			NOK: 'simple_premium_4w_389_1w_55_99_nok',
			BRL: 'simple_premium_4w_219_1w_31_19_brl',
			MXN: 'simple_premium_4w_749_1w_103_99_mxn',
			TRY: 'simple_premium_4w_1519_1w_215_2_try',
			ARS: 'simple_premium_4w_51890_1w_7432_ars',
			COP: 'simple_premium_4w_157390_1w_22392_cop',
			CLP: 'simple_premium_4w_37690_1w_5432_clp',
		},
		primer: 'prd_Dm1hFgWKPxBT',
	},
}
